var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDownloadGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50008 10.625L11.3334 7.79167M8.50008 10.625V2.125V10.625ZM8.50008 10.625L5.66675 7.79167L8.50008 10.625Z",
    stroke: "#77787D",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41675 12.0416L1.85662 13.8018C1.93323 14.1083 2.11008 14.3804 2.35907 14.5748C2.60805 14.7693 2.91488 14.8749 3.23079 14.875H13.7694C14.0853 14.8749 14.3921 14.7693 14.6411 14.5748C14.8901 14.3804 15.0669 14.1083 15.1435 13.8018L15.5834 12.0416",
    stroke: "#77787D",
    strokeWidth: 1.41667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownloadGray);
export default __webpack_public_path__ + "static/media/ic-download-gray.26c94b9c21c63b46d67d550965a7a510.svg";
export { ForwardRef as ReactComponent };